/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseGlobalConfigFragment} from '@amblique/contentful/app/contentful/fragments/global-config/base-global-config.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';

export const FullGlobalConfigFragment = gql`
  ${BaseGlobalConfigFragment}
  ${HeroBannerFragment}
  ${IconFragment}
  ${ImageFragment}
  ${LinkFragment}

  fragment FullGlobalConfigFragment on GlobalConfig {
    ...BaseGlobalConfigFragment

    socialLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    signUpImage {
      ...ImageFragment
    }
    cartPaymentIconsCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
    countriesCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
    showroomHero {
      ...HeroBannerFragment
    }
    showroomFooter {
      ...HeroBannerFragment
    }
    accountHero {
      ...HeroBannerFragment
    }
  }
`;
